import { inject, Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import moment from "moment";
import "moment/locale/th";
import { DateFormat } from "src/utils/enum/date-format.enum";

@Injectable({
  providedIn: "root",
})
export class UtilitiesService {
  constructor() {}
  #router = inject(Router);
  #route = inject(ActivatedRoute);

  /**
   * Dates in the Buddhist era, like everywhere else in this build.
   *
   * moment's `th` locale translates month names but does not shift the year, so
   * this returned 2026 while the course-expiry dates, the blog list and the
   * study-time chart beside it all said 2569. The study record showed both on
   * one screen — a BE heading over an AD table.
   */
  dateFormat(date: any, type: DateFormat) {
    moment.locale(
      localStorage.getItem("language")
        ? localStorage.getItem("language")!
        : "th"
    );
    const be = moment(date).add(543, "year");
    if (type === DateFormat.DATE_TIME) {
      return be.format("DD/MM/YYYY HH:mm");
    } else if (type === DateFormat.DATE) {
      return be.format("DD/MM/YYYY");
    } else if (type === DateFormat.DATE_LOCAL_STRING) {
      return be.format("DD MMM YYYY");
    } else if (type === DateFormat.TIME) {
      return be.format("HH:mm");
    }
  }

  randomNumber() {
    const min = 1;
    const max = 9;
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  currentPath() {
    return this.#router.url;
  }
  currentPathActive(path: string) {
    return this.currentPath() === path;
  }

  _isCreatedToday(compare_date: Date | string) {
    const today = this.dateFormat(new Date(), DateFormat.DATE);
    const pure_date = compare_date.toString().split(" ")[0];
    return today === pure_date;
  }

  isISO8601(dateStr: string) {
    const iso8601Regex =
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(.\d+)?([+-]\d{2}:\d{2}|Z)$/;
    return iso8601Regex.test(dateStr);
  }

  isDDMMYYYY(dateStr: string) {
    const ddmmyyyyRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    return ddmmyyyyRegex.test(dateStr);
  }
}
